// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-components-page-index-js": () => import("./../../../src/components/Page/index.js" /* webpackChunkName: "component---src-components-page-index-js" */)
}

